module.exports = __webpack_public_path__ + "img/ball_nns.75605aa4.png";